"use client";

import HeroSection from "@/components/homePage/HeroSection";
import InterestsSection from "@/components/homePage/InterestsSection";
import ProjectSection from "@/components/homePage/ProjectSection";
import TechStackSection from "@/components/homePage/TechStackSection";
import { useAppSelector } from "@/store/hooks";

export default function HomePage() {
  const isDark = useAppSelector((state) => state.darkMode?.enabled ?? false);

  return (
    <div className={isDark ? "relative dark text-white" : "relative text-neutral-900"}>
      <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col gap-10 px-3 pb-16 pt-5 md:px-6 md:pt-10">
        <HeroSection />
        <ProjectSection />
        <TechStackSection />
        <InterestsSection />
      </div>
    </div>
  );
}
